import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home1 from "./pages/home1";
import AboutPage from "./pages/innerpages/about";
import BlogPage from "./pages/innerpages/blog";
import ContactPage from "./pages/innerpages/contact";
import PortfolioPage from "./pages/innerpages/portfolio";
import ServicesPage from "./pages/innerpages/services";
import ArchitectureExteriorDesign from "./pages/innerpages/services/architecture-exterior-design";
import InteriorDesign from "./pages/innerpages/services/interior-design";
import FurnitureDesign from "./pages/innerpages/services/furniture-design";
import ProjectConsultation from "./pages/innerpages/services/project-consultation";
import SinglePost from "./pages/innerpages/single_post";
import SingleProject from "./pages/innerpages/single_project";
import SingleProject2 from "./pages/innerpages/single_project2";
import AdminPanel from "./pages/AdminPanel";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/innerpages/BlogPost";
import { BlogProvider } from "./common/BlogContext";

function App() {
  return (
    <BlogProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home1 />} />
          <Route path="/home1" element={<Home1 />} />
          <Route path="/innerpages/about" element={<AboutPage />} />
          <Route path="/innerpages/blog" element={<BlogPage />} />
          <Route path="/innerpages/contact" element={<ContactPage />} />
          <Route path="/innerpages/portfolio" element={<PortfolioPage />} />
          <Route path="/innerpages/services" element={<ServicesPage />} />
          <Route
            path="/innerpages/services/architecture-exterior-design"
            element={<ArchitectureExteriorDesign />}
          />
          <Route
            path="/innerpages/services/interior-design"
            element={<InteriorDesign />}
          />
          <Route
            path="/innerpages/services/furniture-design"
            element={<FurnitureDesign />}
          />
          <Route
            path="/innerpages/services/project-consultation"
            element={<ProjectConsultation />}
          />
          <Route path="/innerpages/single_post" element={<SinglePost />} />
          <Route
            path="/innerpages/single_project"
            element={<SingleProject />}
          />
          <Route
            path="/innerpages/single_project2"
            element={<SingleProject2 />}
          />

          {/* Public blog listing */}
          <Route path="/blog" element={<BlogList />} />

          {/* Individual blog post — /blog/123 */}
          <Route path="/blog/:id" element={<BlogPost />} />

          {/* Admin panel */}
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </Router>
    </BlogProvider>
  );
}

export default App;
